export enum Ship {
  adventure = 'DA',
  destiny = 'WD',
  dream = 'DD',
  fantasy = 'DF',
  magic = 'DM',
  wonder = 'DW',
  wish = 'WW',
  treasure = 'WT',
}
